import React, { useEffect, useState } from 'react';
import { Inbox, Download, Loader2 } from 'lucide-react';
import api from '../services/api';

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('academy_token') || ''}` });

// Files a teacher has sent to this student.
export default function MyMaterials() {
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dl, setDl] = useState(null);

  useEffect(() => {
    api.get('/academy/materials', { headers: authHeaders() }).then((r) => setMaterials(r.data.materials || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const download = async (m) => {
    setDl(m.id);
    try {
      const r = await api.get(`/academy/materials/${m.id}/download`, { headers: authHeaders(), responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url; a.download = m.original_filename || m.title || 'material'; a.click();
      URL.revokeObjectURL(url);
    } catch (e) { /* noop */ } finally { setDl(null); }
  };

  if (loading || materials.length === 0) return null;

  const unread = materials.filter((m) => !m.read).length;

  return (
    <div className="mb-6 border-2 border-sky-500/40 bg-sky-500/[0.04] p-4" data-testid="my-materials">
      <div className="flex items-center gap-2 mb-3">
        <Inbox className="w-4 h-4 text-sky-400" />
        <h3 className="text-sm font-black uppercase tracking-[0.2em]">My Materials <span className="text-sky-400">({materials.length})</span></h3>
        {unread > 0 && <span className="ml-1 px-2 py-0.5 bg-sky-500 text-white text-[10px] font-black uppercase tracking-widest animate-pulse" data-testid="materials-unread-badge">{unread} New</span>}
      </div>
      <div className="space-y-2">
        {materials.map((m) => (
          <div key={m.id} className="flex items-center justify-between gap-3 border border-zinc-800 bg-black/40 px-3 py-2" data-testid={`material-${m.id}`}>
            <div className="min-w-0">
              <div className="text-xs font-bold text-white truncate flex items-center gap-2">{!m.read && <span className="w-2 h-2 rounded-full bg-sky-400 flex-shrink-0" />}{m.title}</div>
              <div className="text-[10px] text-zinc-500 truncate">{m.note ? `${m.note} · ` : ''}from {m.sent_by}</div>
            </div>
            <button onClick={() => download(m)} disabled={dl !== null} className="flex-shrink-0 flex items-center gap-1.5 bg-sky-500 hover:bg-sky-400 text-white px-3 py-1.5 text-[10px] font-black uppercase tracking-widest" data-testid={`material-download-${m.id}`}>
              {dl === m.id ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Download className="w-3.5 h-3.5" />} Download
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
